import React from 'react';
import { Play } from 'lucide-react';
import { videoData } from '../mockData';

export const VideoSection = () => {
  return (
    <section id="video" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            See the <span className="text-red-600">Robotic Coupling System</span> in Action
          </h2>
          <div className="w-20 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {videoData.description}
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <div className="relative aspect-video bg-gray-100 rounded-2xl overflow-hidden border-2 border-gray-200 hover:border-red-600 transition-all duration-300 group shadow-lg">
            {videoData.videoPlaceholder ? (
              // YouTube video embed
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/KiSsDCrywuY"
                title="Axicle Robotic Coupling System - Anti-Rollover Development"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              // Actual video embed (to be used when video is available)
              <iframe
                className="absolute inset-0 w-full h-full"
                src="YOUR_VIDEO_URL_HERE"
                title="Axicle Robotic Coupling System Demo"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}

            {/* Decorative corner accents */}
            <div className="absolute top-4 left-4 w-12 h-12 border-l-2 border-t-2 border-red-600/50"></div>
            <div className="absolute top-4 right-4 w-12 h-12 border-r-2 border-t-2 border-red-600/50"></div>
            <div className="absolute bottom-4 left-4 w-12 h-12 border-l-2 border-b-2 border-red-600/50"></div>
            <div className="absolute bottom-4 right-4 w-12 h-12 border-r-2 border-b-2 border-red-600/50"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
